
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import Biography from './components/Biography';
import Philosophy from './components/Philosophy';
import Achievements from './components/Achievements';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <AboutHero />
        <Biography />
        <Philosophy />
        <Achievements />
      </motion.main>

      <Footer />
    </div>
  );
};

export default AboutPage;
